/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Actions_ColInputs */

const en_settings_tickets_actions_col = /** @type {(inputs: Settings_Tickets_Actions_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const zh_settings_tickets_actions_col = /** @type {(inputs: Settings_Tickets_Actions_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Settings_Tickets_Actions_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_actions_col = /** @type {((inputs?: Settings_Tickets_Actions_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Actions_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_actions_col(inputs)
	return zh_settings_tickets_actions_col(inputs)
});
export { settings_tickets_actions_col as "settings.tickets.actions_col" }